module Meevo.Components.Controls {
    "use strict";

    export class MeevoConfirmationStatus implements angular.IDirective {
        restrict = "E";
        scope : any = {
            appointment: '=',
            appointmentService: '=',
            confirmationStatusControl: '=',
            onConfirmStateChangeSuccess: '&',
            commitOnChange: "=?",
            isLabelOnTop: "<?",
            isBgWhite: "<?",
            shortenLabelWhenXs: "<?"
        };

        templateUrl = 'app/components/controls/confirmationStatus/confirmationStatusTemplate.html';
        
        

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            scope.isUpdateStatusToggled = false;
            scope.meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;

            if (angular.isUndefined(scope.commitOnChange)) {
                scope.commitOnChange = true;
            }

            if (angular.isUndefined(scope.isLabelOnTop)) {
                scope.labelOnTop = false;
            }

            if (angular.isUndefined(scope.isBgWhite)) {
                scope.isBgWhite = false;
            }

            if (angular.isUndefined(scope.shortenLabelWhenXs)) {
                scope.shortenLabelWhenXs = false;
            }

            scope.getAppointmentId = () => {
                return angular.isDefined(scope.appointment) ? scope.appointment.id : scope.appointmentService.appointmentId
            }

            scope.getAppointmentEntityVersion = () => {
                return angular.isDefined(scope.appointment) ? scope.appointment.entityVersion : scope.appointmentService.appointmentEntityVersion;
            }
            scope.setAppointmentEntityVersion = (newAppointmentEntityVersion) => {
                if (angular.isDefined(scope.appointment)) {
                    scope.appointment.entityVersion = newAppointmentEntityVersion;
                }
                else {
                    scope.appointmentService.appointmentEntityVersion = newAppointmentEntityVersion;
                }
            }

            scope.setConfirmState = (newConfirmState) => {
                if (angular.isDefined(scope.appointment)) {
                    scope.appointment.confirmState = newConfirmState;
                }
                else {
                    scope.appointmentService.appointmentConfirmState = newConfirmState;
                }
            }

            scope.getConfirmState = ()=> {
                if (angular.isDefined(scope.appointment)) {
                    return scope.appointment.confirmState;
                }
                else if (angular.isDefined(scope.appointmentService)) {
                    return scope.appointmentService.appointmentConfirmState;
                }; 
            }
            scope.confirmationStatusMessages = {
                155: 'LABEL_CONFIRMED',
                158: 'LABEL_UNCONFIRMED',
                157: 'LABEL_WAITING_ON_REPLY_LEFT_MESSAGE',
                1872: 'LABEL_WAITING_ON_REPLY_AWAITING_RESPONSE',
                154: 'LABEL_DO_NOT_CONFIRM',
                1869: 'LABEL_QUEUED',
                1870: 'LABEL_RESCHEDULE',
                20156: 'LABEL_UNABLE_TO_CONTACT'
            }

            if (angular.isDefined(scope.confirmationStatusControl)) {
                scope.confirmationStatusControl.hideStatus = () => {
                    scope.isUpdateStatusToggled = false;
                }
            }

            scope.toggleUpdateStatus = () => {
                if (scope.isUpdateStatusToggled) {
                    scope.isUpdateStatusToggled = false;
                } else {
                    this.securityService.checkSecurityItem(Meevo.Components.Common.SecurityKeys.APPOINTMENTS_CONFIRMATIONMANAGER + Meevo.Components.Common.SecurityParts.KEY_PART_READ).then((item: Model.SecurityItem) => {
                        if (item.securityAccess == Model.SecurityAccessEnum.Grant) {
                            scope.isUpdateStatusToggled = true;
                        }
                        else if (item.securityAccess == Model.SecurityAccessEnum.Deny && item.canElevate) {
                            let defer = this.$q.defer();
                            defer.promise.then(() => {
                                scope.isUpdateStatusToggled = true;
                            });
                            scope.$emit(Meevo.Components.Common.Messages.ELEVATION_CHALLENGE, defer, item.key.replace(/:/gi, '_'), item.displayName, this.identityService.current().userName, item.securityKeyPath);
                        }
                    })    
                }
            }
            
            scope.contacted = () => {
                if (scope.commitOnChange) {
                    this.restServer.addContactAttempt(scope.getAppointmentId(), (response) => {

                        // Update status to Unconfirmed after adding contact attempt
                        this.restServer.changeAppointmentConfirmState(scope.getAppointmentId(), scope.getAppointmentEntityVersion(),
                            Meevo.Model.AppointConfirmStateEnum.UnableToContact, (response) => {
                                scope.localOnConfirmStateChangeSuccess(response);
                            });
                    });
                }
                else {
                    scope.setConfirmState(Meevo.Model.AppointConfirmStateEnum.UnableToContact);
                }
            }

            scope.leftMessage = () => {
                scope.performGenericStateChange(Meevo.Model.AppointConfirmStateEnum.LeftMessage);
            }

            scope.doNotConfirm = () => {
                scope.performGenericStateChange(Meevo.Model.AppointConfirmStateEnum.DoNotConfirm);
            }

            scope.performGenericStateChange = (newState : Meevo.Model.AppointConfirmStateEnum) =>
            {
                if (scope.commitOnChange) {
                    this.restServer.changeAppointmentConfirmState(scope.getAppointmentId(), scope.getAppointmentEntityVersion(),
                        newState, (response) => {
                            scope.localOnConfirmStateChangeSuccess(response);
                        });
                }
                else {
                    scope.setConfirmState(newState);
                }
            }

            scope.resetConfirmState = () => {
                if (scope.commitOnChange) {
                    this.restServer.unConfirmAppointment(scope.getAppointmentId(), scope.getAppointmentEntityVersion(), (response) => {
                        scope.localOnConfirmStateChangeSuccess(response);
                    });
                }
                else {
                    scope.setConfirmState(Meevo.Model.AppointConfirmStateEnum.Unconfirmed);
                }
            }

            scope.isAppointmentConfirmed = () => {
                if (angular.isDefined(scope.appointment)) {
                    return scope.appointment.confirmState === Meevo.Model.AppointConfirmStateEnum.Confirmed
                }
                else if (angular.isDefined(scope.appointmentService)) {
                    return scope.appointmentService.appointmentConfirmState === Meevo.Model.AppointConfirmStateEnum.Confirmed
                };
            }

            scope.confirmAppointmentByPhone = () => {
                if (scope.commitOnChange) {
                    this.restServer.confirmAppointment(scope.getAppointmentId(), scope.getAppointmentEntityVersion(),
                        (response) => {
                            scope.localOnConfirmStateChangeSuccess(response);
                        });
                }
                else {
                    scope.setConfirmState(Meevo.Model.AppointConfirmStateEnum.Confirmed);
                }
            }

            scope.localOnConfirmStateChangeSuccess = (response) =>
            {
                scope.setAppointmentEntityVersion(response.entityVersion);
                if (_.isFunction(scope.onConfirmStateChangeSuccess)) {
                    scope.onConfirmStateChangeSuccess({ appointment: scope.appointment, response: response })    
                };
            }
        }
        

        constructor(private restServer,
            private securityService: Meevo.Components.Common.ISecurityService,
            private identityService: Meevo.Components.Common.IIdentityService,
            private $q: ng.IQService) { }

        static factory(): angular.IDirectiveFactory {
            let directive = (restServer, securityService, identityService,$q) => {
                return new MeevoConfirmationStatus(restServer, securityService,identityService,$q);
            };
            directive.$inject = ["restServer",
                "meevo.components.common.SecurityService",
                "meevo.components.common.IdentityService",
                "$q"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoConfirmationStatus", MeevoConfirmationStatus.factory());
}